import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import {
  StyledTooltip,
  TextHelperWrapper,
  TextHelperTypography,
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import {
  longTextEndDate,
  rootExistedHint,
  rootWrongFormatHint,
  quickConfigurationTextHelperPlainInstance,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import {
  checkServiceNowTicket,
  checkWBSECode,
  checkDailyDataVolume,
  checkConcurrentUsers,
  checkBenefitsExpected,
  checkPOCname,
  createMaxDate
} from "./CommonFunctions";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import TextsmsIcon from "@material-ui/icons/Textsms";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { isValid } from "date-fns";
import { FlashOnRounded, FormatColorReset } from "@material-ui/icons";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";

const aSelectedInstanceFields = {
  DMSId: { type: "string", fieldName: "dmsId" },
  ClientName: { type: "string", fieldName: "clientName" },
  DeployRegion: { type: "object", fieldName: "deployRegion" },
  SAPContractID: { type: "object", fieldName: "sapContractId" },
  AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};

/**
 * Plain Instance Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const Ec2ClaudeCode = ({
  values, // the value would be changed by user's input
  updateECCForm, //the function to update PIForm values which is from redux
  updateASelectedInstanceByField,
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  getSelectedEnvironment,
  minDate,
  maxDate,
  getServiceEndDate,
  isServiceEndDateInvalid,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  vendorName,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  const config = configurationType === "quick";

  // check whether values are valid
  const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDailyDataVolumeValid, setIsDailyDataVolumeValid] = useState(true);
  const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  //   const [isUsersFieldValid, setUsersField] = useState(false);
  const [isNoteVisible, setNoteVisible] = useState(true);

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updateECCForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateECCForm("IsContractIdAvailable", "no")
      updateECCForm("SAPContractID", "0000000000")
      updateECCForm("EndToEndUId", "")
      setSapContractCodeLength(10)
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateECCForm("SAPContractID", "")
      // updateECCForm("ClientName", "")
      updateECCForm("EndToEndUId", "")
      setSapContractCodeLength(0)
    }
  };


  useEffect(() => {
    updateASelectedInstanceByField({
      field: "aaamPlatformType",
      value: {
        Value: "myWizard AiOps Plain Instance",
      },
    });
  }, []);

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    //updateECCForm("ClientName", "")
    updateECCForm("EndToEndUId", "")
    updateECCForm("Company", "")
    updateECCForm("AvanadeCountry", "")
    updateECCForm("AccentureCountry", "")
    updateECCForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateECCForm("ClientName", externalClientData[0])
      updateECCForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateECCForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateECCForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateECCForm("AccentureCountry", externalClientData[4])
      updateECCForm("ContractAvailabilityDate", "")
      updateECCForm("IsContractIdAvailable", "yes")
    }
  }

  if (!config) {
    (isDailyDataVolumeValid ||
      isConcurrentUsersValid ||
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isServiceNowTicketValid ||
      isDailyDataVolumeValid ||
      isConcurrentUsersValid ||
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  updateECCForm("VendorName", vendorName);
  updateECCForm("ConfigurationType", configurationType);

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updateECCForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateECCForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateECCForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    }
    else {
      const value = event.target.value;
      event.preventDefault();
      updateECCForm(fieldName, value);
      // if (fieldName === "Environment") {
      //   getSelectedEnvironment(value);
      // }
      if (fieldName === "RITM") {
        setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
      }
      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        if (wbsevalue.trim() === "CBYDQ001") {
          setIsWBSECodeMDIValid(false)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "DailyDataVolume") {
        if (value[0] === "0") {
          setIsDailyDataVolumeValid(false);
        } else if (parseInt(value, 10) > 200) {
          setIsDailyDataVolumeValid(false);
        } else {
          setIsDailyDataVolumeValid(checkDailyDataVolume(value));
        }
      }
      if (fieldName === "ConcurrentUsers") {
        setIsConcurrentUsersValid(checkConcurrentUsers(value));
      }
      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
      //update aSelectedInstance as other step relies on this data
      if (aSelectedInstanceFields[fieldName]) {
        const afieldDetails = aSelectedInstanceFields[fieldName];
        afieldDetails.type === "string" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value,
          });
        afieldDetails.type === "object" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value: {
              Value: value,
            },
          });
      }

      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateECCForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dhuat")
        } else if (value == "virginia") {
          setRegionCode("dh1uat")
        } else if (value == "frankfurt") {
          setRegionCode("dh2uat")
        } else if (value == "singapore") {
          setRegionCode("dh3uat")
        } else if (value == "tokyo") {
          setRegionCode("dh4uat")
        } else if (value == "ireland") {
          setRegionCode("dh5uat")
        } else if (value == "london") {
          setRegionCode("dh6uat")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
          updateECCForm("Tier", "")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateECCForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateECCForm("Tier", "")
        } else {
          setEnv("")
          updateECCForm("Tier", "")
        }
      }
    }
  };

  getSelectedEnvironment(env);
  updateECCForm("Environment", env);

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateECCForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updateECCForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);

  const isGDPR = values.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateECCForm(fieldName, value);
  };

  //form validation
  const validateInputFields = (step) => {
    let ispass = true;
    const fieldsRequired = {
      'step0': [
        'ProjectName',
        'WBSEcode',
        'SecondaryPOC',
        'DataClassification',
        'TeamName',
        'RequestNotes',
      ],

      'step1': [
        'DeploymentRegion',
        'DomainContextRoot',
        'Environment',
      ],

      'step2': [
        'AdminDistributionGroup',
        'TentativeServiceEndDate',
      ]
    }

    if (config) {
      //fieldsRequired['step0'].push('ClientNameInternal');
    } else {
      if (isChecked)
        fieldsRequired['step0'].push('SAPContractID');
      else {
        fieldsRequired['step0'].push('Pocdetails', 'ClientName', 'RITM');
      }
      fieldsRequired['step2'].push('UsersDistributionGroup');
    }

    for (const fieldname of fieldsRequired[step]) {
      if (fieldname === "WBSEcode" && !isWBSEValid) {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
        ispass = false;
      } else if (values[fieldname] === "") {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
        ispass = false;
      } else {
        document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "";
      }
    }

    if (step === 'step2' && ispass)
      formClickSubmit();
    else
      return ispass;
  }

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={vendorName === "MCC" ? 0 : 15}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a contract ID available?
                </ConfigurationFormLabel>

                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""}

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 28 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }

            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }

                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponent
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <Grid item xs={4}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                  </Grid>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >
                }
                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                </Grid >
                {config &&
                  <Grid item xs={4}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                  </Grid>
                }
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                {/* {config &&
                <Grid item xs={4}>
                  {FormField.ClientNamePlatformInternal(handleChange, values)}
                </Grid >
              } */}
                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            {/* {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}.mywizard-aiops.com/{domainContextRoot}</span></p> : ""} */}
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >

                {/* {vendorName !== "MCC" &&
                  <Grid item xs={12}>
                    {PlatformFormField.GDPRPlatformField(
                      values,
                      handleChange,
                      isGDPR,
                      classes,
                      config,
                      isChecked
                    )}
                  </Grid>
                } */}

                {vendorName === "MCC"
                  ? <Grid item xs={3}>
                    {PlatformFormField.DeploymentRegionEC2ClaudePlatformField(
                      values,
                      handleChange
                    )}
                  </Grid>
                  : <Grid item xs={3}>
                    {PlatformFormField.DeploymentRegionEC2ClaudePlatformField(
                      values,
                      handleChange,
                      isGDPR
                    )}
                  </Grid>
                }

                <Grid item xs={4}>
                  {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                    values,
                    handleChangeRootSuggestions,
                    // handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    rootWrongFormatHint,
                    externalClientData,
                    domainContextRoot,
                    isLoading
                  ) : PlatformFormField.DomainContextRootPlatformField(
                    values,
                    handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    isLoading
                  )}
                </Grid>
                {!config &&
                  <Grid item xs={4}>
                    {PlatformFormField.DailyDataVolumePlatformField(
                      values,
                      handleChange,
                      isConcurrentUsersValid
                    )}
                  </Grid>
                }
                {/* <Grid item xs={3}>
                {PlatformFormField.EnvironmentPlatformField(values, handleChange)}
              </Grid> */}
                <Grid item xs={3}>
                  {PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
                {/* {values.Environment === "Production" &&
                <Grid item xs={3}> 
                  {PlatformFormField.TierPlatformField(values, handleChange)}
                </Grid>
              } */}
              </Grid>
            </div>
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={6}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              {!config &&
                <Grid item xs={6}>
                  {FormField.UsersDistributionGroupField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
            </Grid>
          </div>
        }
        history={history}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
    </>
  );
};

const MSTP = (state, ownProps) => ({
  isRootExist: state.fui.isRootExist,
  values: state.fui.ECCForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
  isWBSEValid: state.fui.isWBSEValid,
});

export default connect(MSTP, {
  updateECCForm: fuiRedux.updateECCForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(Ec2ClaudeCode));
